import { createAction } from '@src/redux/helpers/createAction';
import { SAVE_USER_INFO, GET_FETCHUSER } from './constants';
import { getFetchUserSaga } from './sagas';

export const saveUserInfo = (payload) => {
  return createAction({
    type: SAVE_USER_INFO,
    payload,
  });
};

export const getFetchUser = (payload, onSuccess, onError) => {
  return createAction({
    type: GET_FETCHUSER,
    cache: false,
    meta: { onSuccess, onError, async: getFetchUserSaga },
    payload,
  });
};
